import { getMarkJS } from './constants';

export default async function unmarkElements(
    markId: string,
    callback: (element: HTMLElement) => void
) {
    const MarkJS = await getMarkJS();
    const context = document.querySelectorAll('.' + markId);
    const marker = MarkJS.call(MarkJS, context);
    marker.unmark({ className: markId });

    for (let i = 0; i < context.length; i++) {
        const markedElement = context[i] as HTMLElement;
        callback(markedElement);
    }
}
